import { styled } from "@vitality-ds/system";
import BaseEmptyStateImageStyles from "./styles/BaseEmptyStateImage.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseEmptyStateImage = styled("div", BaseEmptyStateImageStyles);